import { AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, DoCheck, Inject, OnInit, ViewChild } from '@angular/core';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-editaddress',
  templateUrl: './editaddress.component.html',
  styleUrls: ['./editaddress.component.scss']
})
export class EditaddressComponent implements OnInit {

  isSaving = false;
  tabIndex = 0;

  mailingForm!: FormGroup;
  serviceForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditaddressComponent>,
    private customerService: CustomerService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    const c = this.customerService.currentCustomer;

    this.mailingForm = this.fb.group({
      streetNo: [c.MailingStreetNumber, Validators.required],
      streetName: [c.MailingStreetName, Validators.required],
      streetType: [c.mailingStreetType],
      city: [c.MailingCity, Validators.required],
      state: [c.MailingState, [Validators.required, Validators.maxLength(2)]],
      zip: [c.MailingZipcode, [Validators.required, Validators.pattern('[0-9]*')]]
    });

    this.serviceForm = this.fb.group({
      streetNo: [c.ServiceStreetNumber, Validators.required],
      streetName: [c.ServiceStreetName, Validators.required],
      streetType: [c.serviceStreetType],
      city: [c.ServiceCity, Validators.required],
      state: [c.ServiceState, [Validators.required, Validators.maxLength(2)]],
      zip: [c.ServiceZipcode, [Validators.required, Validators.pattern('[0-9]*')]]
    });
  }

  saveMailing() {
    this.saveAddress(this.mailingForm, '1', this.customerService.currentCustomer.MailingAddressId, true);
  }

  saveService() {
    this.saveAddress(this.serviceForm, '2', this.customerService.currentCustomer.ServiceAddressId, false);
  }

  private saveAddress(form: FormGroup, type: string, addressId: any, isMailing: boolean) {
    if (form.invalid || !this.data.editMode) return;

    const v = form.value;

    const payload = {
      ADDRESS_ID: addressId,
      SELECTEDADDRTYPECODE: type,
      STREETNUMBER: this.userService.IsCustomUiChange? v.streetNo : v.streetNo.toUpperCase(),
      STREETNAME: this.userService.IsCustomUiChange? v.streetName : v.streetName.toUpperCase(),
      STREETTYPE: this.userService.IsCustomUiChange? v.streetType : v.streetType?.toUpperCase(),
      CITY: this.userService.IsCustomUiChange? v.city : v.city.toUpperCase(),
      STATEPROVINCE: this.userService.IsCustomUiChange? v.state : v.state.toUpperCase(),
      ZIP: v.zip
    };

    this.isSaving = true;

    this.customerService.updateaddress(
      JSON.stringify(payload),
      this.customerService.currentCustomer.PersonCompanyId
    ).subscribe({
      next: () => {
        Swal.fire({
          text: 'Address Updated Successfully',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => this.finishSave(payload, isMailing));
      },
      error: err => {
        Swal.fire({ text: err, icon: 'error' });
        this.isSaving = false;
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  private finishSave(payload: any, isMailing: boolean) {
    const c = this.customerService.currentCustomer;

    if (isMailing) {
      c.MailingStreetNumber = payload.STREETNUMBER;
      c.MailingStreetName = payload.STREETNAME;
      c.MailingCity = payload.CITY;
      c.MailingState = payload.STATEPROVINCE;
      c.MailingZipcode = payload.ZIP;
      c.mailingStreetType = payload.STREETTYPE;
    } else {
      c.ServiceStreetNumber = payload.STREETNUMBER;
      c.ServiceStreetName = payload.STREETNAME;
      c.ServiceCity = payload.CITY;
      c.ServiceState = payload.STATEPROVINCE;
      c.ServiceZipcode = payload.ZIP;
      c.serviceStreetType = payload.STREETTYPE;
    }

    this.customerService.getCustomerById(c.Id).subscribe((detail: Customer[]) => {
      const temp = new Customer();
      temp.setUpFromWS(detail);

      c.ServiceStreetAddress1 = temp.ServiceStreetAddress1;
      c.MailingStreetAddress1 = temp.MailingStreetAddress1;

      this.isSaving = false;
      this.dialogRef.close(true);
    });
  }
}

